import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Image as ImageIcon, X, Crosshair } from 'lucide-react';
import { FocalPointPicker } from '../shared/FocalPointPicker';

export const FeaturedImageCard = ({ formData, onChange, onUpload }) => (
  <Card>
    <CardHeader>
      <CardTitle>Imagem Destacada</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      {formData.featured_image ? (
        <div className="space-y-3">
          <div className="relative">
            <FocalPointPicker
              src={formData.featured_image}
              value={formData.featured_image_position || 'center'}
              onChange={(v) => onChange('featured_image_position', v)}
              className="w-full aspect-video rounded-lg"
            />
            <button
              type="button"
              onClick={() => onChange('featured_image', '')}
              className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600 z-10"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="flex items-center justify-between">
            <p className="text-xs text-slate-500">Arraste a imagem acima para escolher exatamente a parte visível.</p>
            <button
              type="button"
              onClick={() => onChange('featured_image_position', '50% 50%')}
              className="flex items-center gap-1 text-xs text-[#1e4e7e] hover:underline flex-shrink-0"
              data-testid="reset-image-position"
            >
              <Crosshair className="w-3 h-3" />
              Centralizar
            </button>
          </div>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center h-40 border-2 border-dashed border-slate-200 rounded-lg cursor-pointer hover:border-primary transition-colors">
          <ImageIcon className="w-8 h-8 text-slate-400 mb-2" />
          <span className="text-sm text-slate-500">Clique para enviar</span>
          <input type="file" accept="image/*" onChange={onUpload} className="hidden" data-testid="featured-image-upload" />
        </label>
      )}
      <div>
        <Label htmlFor="featured_image_alt">Texto alternativo</Label>
        <Input
          id="featured_image_alt"
          value={formData.featured_image_alt}
          onChange={(e) => onChange('featured_image_alt', e.target.value)}
          placeholder="Descrição da imagem"
          className="mt-1"
        />
      </div>
    </CardContent>
  </Card>
);
